import { baseUrl } from "util/APIBaseUrl";
import { makeRequest } from "util/APIHelper";
import getRequest from "util/APIHelperGet";
import patchRequest from "util/APIHelperPatch";
import putRequest from "util/APIHelperPut";
import postRequest from "util/APIHelperPost";

// eslint-disable-next-line import/prefer-default-export
export const getMissingPaymentMethodCustomersCount = async () => {
  const { payload } = await getRequest(
    `${baseUrl}/customers?${new URLSearchParams({
      limit: 10,
      page: 0,
      orderBy: JSON.stringify({}),
      filter: JSON.stringify({
        paymentMethodType: ["MISSING"],
      }),
    })}`
  );

  return !!payload?.count;
};

export const getEmployeeSuccessManagersList = async (limit = 1000) => {
  const { payload } = await getRequest(
    `${baseUrl}/users/list?${new URLSearchParams({
      limit,
      filter: JSON.stringify({
        Role: ["EdgeAdmin", "EdgeEmployee"],
      }),
    })}`
  );

  return payload;
};

export const getEmployeeOfferLetterSignedURL = async (name, size, fileType) => {
  const { payload } = await getRequest(
    `${baseUrl}/employees/document/upload-url?${new URLSearchParams({
      fileName: name,
      fileType,
      fileSize: size,
    })}`
  );

  return payload;
};

export const updateEmployeePersonalDetails = async (body, anniversaryBasedTimeOff = false) => {
  return await makeRequest(
    {
      path: `${baseUrl}${anniversaryBasedTimeOff ? "/v2" : ""}/employee/${body.employeeId}`,
      contentType: "application/json",
      method: "PATCH",
      body: JSON.stringify(body),
    },
    false
  );
};

export const uploadWorkforcePhoto = async (actions) => {
  await fetch(`${baseUrl}${actions.request}`, {
    method: "POST",
    headers: {},
    body: actions.formData,
  });
};

export const addNewEmployee = async (body, anniversaryBasedTimeOff = false, loginRebrand = false) => {
  let version = "/v2";
  if (loginRebrand) {
    version = "/v4";
  } else if (anniversaryBasedTimeOff) {
    version = "/v3";
  }
  return await postRequest(`${baseUrl}${version}/employees`, JSON.stringify(body));
};

export const assignEmployeeToACustomer = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/v2/employee/${employeeId}/assign`, JSON.stringify(body));
};

export const assignEmployeeToACustomerV3 = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/v3/employee/${employeeId}/assign`, JSON.stringify(body));
};

export const assignEmployeeToACustomerV4 = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/v4/employee/${employeeId}/assign`, JSON.stringify(body));
};

export const assignEmployeeToACustomerV5 = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/v5/employee/${employeeId}/assign`, JSON.stringify(body));
};

export const editEmployeeAssignment = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/employee/${employeeId}/editAssignment`, JSON.stringify(body));
};

export const editEmployeeAssignmentV2 = async (employeeId, employmentHistoryId, body) => {
  return await putRequest({
    path: `/employee/${employeeId}/assignment/${employmentHistoryId}`,
    body,
    stringifyBody: true,
  });
};

export const unassignEmployeeFromACustomer = async (employeeId) => {
  return await getRequest(`${baseUrl}/employee/${employeeId}/unassign`);
};

export const unassignEmployeeFromACustomerV2 = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/v2/employee/${employeeId}/unassign`, JSON.stringify(body));
};

export const getEmployeeDetailsByIDV2 = async (employeeId) => {
  return await getRequest(`${baseUrl}/v2/employee/${employeeId}`);
};

export const markEmployeeAsInactive = async (employeeId, body) => {
  return await postRequest(`${baseUrl}/employee/${employeeId}/deactivate`, JSON.stringify(body));
};

export const reactivateEmployee = async (employeeId) => {
  return await postRequest(`${baseUrl}/employee/${employeeId}/reactivate`, JSON.stringify({}));
};

export const updateSkipPaymentOption = async (customerId, body, version = "") => {
  return await patchRequest({
    path: `${version}${version ? "/" : ""}customer/${customerId}`,
    body,
    stringifyBody: true,
  });
};

export const updateAllowCreditCardOption = async (customerId, body) => {
  return await putRequest({
    path: `/customer/${customerId}/credit-card-settings`,
    body,
    stringifyBody: true,
  });
};

export const updateCustomerSetting = async (customerId, body) => {
  return await patchRequest({
    path: `customer/${customerId}`,
    body,
    stringifyBody: true,
  });
};
